import { ThemeContext, ThemeType } from 'grommet';
import React from 'react';

export const useTheme = () => React.useContext(ThemeContext) as ThemeType;